export default __webpack_public_path__ + "static/media/ID.3fa4a3f7.svg";